import { useTranslation } from '@pancakeswap/localization'
import { Button, Flex } from '@pancakeswap/uikit'
import { NextLinkFromReactRouter } from 'components/NextLink'
import Select, { OptionProps } from 'components/Select/SelectV2'
import { useRouter } from 'next/router'
import styled from 'styled-components'


interface FarmTabButtonsProps {
  hasStakeInFinishedFarms: boolean
}

const FarmTabButtons: React.FC<React.PropsWithChildren<FarmTabButtonsProps>> = ({ hasStakeInFinishedFarms }) => {
  const router = useRouter()
  const { t } = useTranslation()

  const handleStakeInFinishedOptionChange = (option: OptionProps): void => {
    if(option.value === false){
      router.push('/farms')
    }
    if(option.value){
      router.push('/farms/history')
    }
  }

  let activeIndex
  switch (router.pathname) {
    case '/farms':
      activeIndex = 0
      break
    case '/farms/history':
      activeIndex = 1
      break
    case '/_mp/farms/history':
      activeIndex = 1
      break
    case '/farms/archived':
      activeIndex = 2
      break
    default:
      activeIndex = 0
      break
  }
  function handleClick(url:string){
    window.location.href=url
  }
  return (
    // <Wrapper>
    //   <Select
    //       options={[
    //           {
    //               label: t('Live'),
    //               value: false,
    //           },
    //           {
    //               label: t('Finished'),
    //               value: true,
    //           }
    //       ]}
    //       onChange={handleStakeInFinishedOptionChange}
    //         />
    // </Wrapper>
    <Wrapper>
        <StyTab isActive={activeIndex === 0 ? !false : false} as={NextLinkFromReactRouter} to="/farms">
            {t("Live")}
        </StyTab>
        <StyTab isActive={activeIndex === 1} as={NextLinkFromReactRouter} to="/farms/history">
            {t("Finished")}
        </StyTab>
    </Wrapper>
  )
}

export default FarmTabButtons

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 200px;
  @media only screen and (max-width: 600px){
      width:100%;
      margin-top:1.5rem;
  }
`
const StyTab = styled(Button)<{ isActive:boolean }>`
    width: 50%;
    align-items:center;
    justify-content: center;
    text-align: center;
    height: 32px;
    cursor: pointer;
    font-size:18px;
    background-color: transparent;
    font-family: 'Marcellus', serif;
    color: ${({theme}) => theme.colors.text};
    border-bottom: 2px solid ${({ theme, isActive }) => isActive ? theme.colors.text : "none" };
    @media screen and (max-width: 600px) {
        width: 50%;
    }
`